import type { ApprovalPolicyPublic } from './api';

/** Editing access must not replace a saved review chain with its active subset. */
export function approvalPolicyDraft(policy?: ApprovalPolicyPublic) {
  return {
    required: policy?.configured_required_count ?? policy?.required_count ?? 1,
    ids: policy?.configured_user_ids ?? (policy?.users || []).map(person => person.id),
    ordered: policy?.configured_ordered ?? (policy?.ordered === true),
    // During a mixed-version rollout an old payload may only say that the
    // hidden list exists. Do not let an unrelated edit save an empty chain.
    incompleteNamedApprovers: policy?.named_approvers_unavailable === true && policy.configured_user_ids === undefined,
  };
}
